import { FunctionComponent } from 'react'
import {
  Box,
  CardContentGrid,
  CollapsibleCard,
  Skeleton,
  Typography,
} from '@black-bear-energy/rucksack'
import { ArrayAndStorageIcon } from './ArrayAndStorageIcon'
import { CardContentField } from './CardContentField'
import { SiteRFPDetails } from '@black-bear-energy/black-bear-energy-common'
import { formatSignificantFigures } from '../helpers/formatSignificantFigures'

export const SiteDetailsCard: FunctionComponent<SiteDetailsCardProps> = ({
  siteRFPDetails,
  isFetching,
}) => {
  const formattedSystemSize =
    siteRFPDetails?.systemSize != null
      ? formatSignificantFigures(siteRFPDetails.systemSize) + ' MW'
      : null
  const formattedBatterySize =
    siteRFPDetails?.storageSize != null
      ? formatSignificantFigures(siteRFPDetails.storageSize) + ' MW'
      : null
  const formattedBatteryCapacity =
    siteRFPDetails?.storageCapacity != null
      ? formatSignificantFigures(siteRFPDetails.storageCapacity) + ' MWh'
      : null

  return (
    <CollapsibleCard
      title="Site Details"
      titleAdornment={
        <ArrayAndStorageIcon
          arrayLocation={siteRFPDetails?.arrayLocation}
          storageSize={siteRFPDetails?.storageSize}
        />
      }
    >
      <CardContentGrid columns={4}>
        <Box
          sx={{
            display: 'inline-flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '8px',
          }}
        >
          {isFetching && <Skeleton variant="rounded" />}
          {!isFetching && siteRFPDetails && (
            <>
              <Typography variant="body2">{siteRFPDetails.address}</Typography>
              <Typography variant="body2">
                {siteRFPDetails.city}, {siteRFPDetails.state}{' '}
                {siteRFPDetails.zipCode}
              </Typography>
            </>
          )}
        </Box>
        <CardContentField
          label="Section"
          value={siteRFPDetails?.section}
          isFetching={isFetching}
        />
        <CardContentField
          label="Program"
          value={siteRFPDetails?.programName}
          isFetching={isFetching}
        />
        <CardContentField
          label="Utility"
          value={siteRFPDetails?.utilityName}
          isFetching={isFetching}
        />
        <Box />
        {formattedSystemSize && (
          <CardContentField
            label="System Size"
            value={formattedSystemSize}
            isFetching={isFetching}
          />
        )}
        {formattedBatterySize && (
          <CardContentField
            label="Battery Size"
            value={formattedBatterySize}
            isFetching={isFetching}
          />
        )}
        {formattedBatteryCapacity && (
          <CardContentField
            label="Battery Capacity"
            value={formattedBatteryCapacity}
            isFetching={isFetching}
          />
        )}
      </CardContentGrid>
    </CollapsibleCard>
  )
}

export interface SiteDetailsCardProps {
  siteRFPDetails?: SiteRFPDetails | null
  isFetching: boolean
}
